/**
 * Deploy-specific configuration whitelists
 */
export default [
    'bridgeChannel',
    'disableRecordAudioNotification'
];
